import { Navigate } from 'react-router';
import { RootState } from '../redux/store';
import { UserRole } from '../params/redux';
import { useSelector } from 'react-redux';

interface ProtectedRouteProps {
    roles: UserRole[];
    children: JSX.Element;
}

const ProtectedRoute = ({ roles, children }: ProtectedRouteProps) => {
    const { currentUser } = useSelector((state: RootState) => state.app);
    const restrictedSubscriptionPages = ['/app/subscription', '/app/subscription-callback'];

    if (!currentUser?.role || !roles.includes(currentUser.role)) {
        if (currentUser?.role === 'client') {
            return <Navigate to={`/app/client/${currentUser.client_id}/dashboard`} replace />;
        }
        return <Navigate to="/app/dashboard" replace />;
    } else if (currentUser?.role === 'organizationOwner' && currentUser?.billing_enabled === false && !restrictedSubscriptionPages.includes(location.pathname)) {
        return <Navigate to="/app/subscription" replace />;
    }

    return children;
};

export default ProtectedRoute;
